class OuroohProductDescription extends HTMLElement {
  /** @type {HTMLInputElement | null} */
  #toggle = null;

  /** @type {HTMLElement | null} */
  #content = null;

  connectedCallback() {
    this.#toggle = this.querySelector('.ourooh-product-description__toggle');
    this.#content = this.querySelector('.ourooh-product-description__content');

    if (!this.#toggle || !this.#content) return;

    this.#content.setAttribute('role', 'button');
    this.#content.setAttribute('tabindex', '0');
    this.#syncExpandedState();

    this.addEventListener('click', this.#handleClick);
    this.#content.addEventListener('keydown', this.#handleKeyDown);
    this.#toggle.addEventListener('change', this.#syncExpandedState);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
    this.#content?.removeEventListener('keydown', this.#handleKeyDown);
    this.#toggle?.removeEventListener('change', this.#syncExpandedState);
  }

  /**
   * @param {MouseEvent} event
   */
  #handleClick = (event) => {
    const target = event.target;
    if (!(target instanceof Element) || !this.#content?.contains(target)) return;
    if (target.closest('a, button, input, label, select, textarea')) return;

    event.preventDefault();
    this.#setExpanded(!this.#toggle?.checked);
  };

  /**
   * @param {KeyboardEvent} event
   */
  #handleKeyDown = (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    this.#setExpanded(!this.#toggle?.checked);
  };

  /**
   * @param {boolean} expanded
   */
  #setExpanded(expanded) {
    if (!this.#toggle) return;

    this.#toggle.checked = expanded;
    this.#toggle.dispatchEvent(new Event('change', { bubbles: true }));
  }

  #syncExpandedState = () => {
    if (!this.#toggle || !this.#content) return;

    this.#content.setAttribute('aria-expanded', String(this.#toggle.checked));
  };
}

if (!customElements.get('ourooh-product-description')) {
  customElements.define('ourooh-product-description', OuroohProductDescription);
}
